export enum SplitDirectionEnum {
  LEFT = "Left",
  RIGHT = "Right",
  BOTH = "Both",
}
